import React, { Component } from 'react';
import { Loader } from './index';
import styled from 'styled-components';

import instagramIcon from '../../assets/images/instagram-icon.png';
import fbMessengerIcon from '../../assets/images/fbmessenger-icon.png';
import facebookIcon from '../../assets/images/facebook-icon.png';

type Props = {
  image: any,
  source: title,
  description: string,
  source: string,
  link: string,
  subStr: Function
};

type State = {
  loading: boolean
};

const FBMessengerUrl = styled.div`
  margin-right: 30px;
  min-width: 250px;
`;
const Container = styled.a`
  float: left;
  max-width: 250px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background-color: #fff;
  margin: 5px 0;
  text-decoration: none;
  border: ${(props) => (props.isFacebook ? '1px solid #ddd' : 'none')};
`;
const Image = styled.img`max-width: 100%;`;
const ImageContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  -webkit-border-radius: ${(props) => (props.isFacebook ? '0' : '12px')};
  -moz-border-radius: ${(props) => (props.isFacebook ? '0' : '12px')};
  border-radius: ${(props) => (props.isFacebook ? '0' : '12px')};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  max-height: ${(props) => (props.isFacebook ? '135px' : 'none')};
`;
const DataContainer = styled.div`margin: 0;`;
const ActionsContainer = styled.div`padding: 10px;`;
const FBData = styled.div`position: relative;`;
const ProfileContainer = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  padding: 10px;
  background: #3578e5;
  -webkit-border-top-left-radius: 12px;
  -webkit-border-top-right-radius: 3px;
  -moz-border-radius-topleft: 12px;
  -moz-border-radius-topright: 3px;
  border-top-left-radius: 12px;
  border-top-right-radius: 3px;
`;
const ProfileName = styled.p`
  color: #fff;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin: 0;
  word-wrap: break-word;
  text-align: left;
  word-break: break-word;
  line-height: 16px;
  text-decoration: underline;
`;
const Link = styled.p`
  color: #999;
  font-size: 12px;
  text-align: left;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const Title = styled.p`
  font-size: 12px;
  color: #111;
  font-weight: bold;
  text-decoration: none;
  text-align: left;
  margin: 0 0 5px 0;
`;
const Description = styled.p`
  font-size: 12px;
  color: #666;
  text-decoration: none;
  text-align: left;
  margin: 0 0 5px 0;
  line-height: 14px;
`;
const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
const Logo = styled.img`height: 24px;`;
const Sum = styled.span`
  font-size: 24px;
  color: #aaa;
  margin: 0 10px;
  font-weight: bold;
`;

class FBMessengerUrlComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2500);
  }

  renderContent = () => {
    const { image, title, description, source, link, subStr, facebook } = this.props;

    if (this.state.loading) {
      return <Loader inverted active />;
    }

    return (
      <Container href={link} target="_blank" isFacebook={facebook}>
        <ProfileContainer>
          <ProfileName>{link}</ProfileName>
        </ProfileContainer>
        <ImageContainer isFacebook={facebook}>
          <Image src={image} alt={subStr(description)} />
        </ImageContainer>
        {facebook && (
          <FBData className="instagramDM-data">
            <DataContainer>
              <ActionsContainer>
                <Title>{title}</Title>
                <Description>{subStr(description, 191)}</Description>
                <Link>{source}</Link>
              </ActionsContainer>
            </DataContainer>
          </FBData>
        )}
      </Container>
    );
  };

  renderSource = () => {
    if (this.props.facebook) {
      return <Logo src={facebookIcon} alt="Facebook" />;
    }

    return <Logo src={instagramIcon} alt="Instagram" />;
  };

  render() {
    return (
      <div>
        <h4 className="preview-title">FB Messenger URL</h4>
        <LogosContainer>
          {this.renderSource()}
          <Sum>+</Sum>
          <Logo src={fbMessengerIcon} alt="Fb Messenger" />
        </LogosContainer>

        <FBMessengerUrl className="preview-container">
          {this.renderContent()}
          <div className="clearfix" />
        </FBMessengerUrl>
      </div>
    );
  }
}

export default FBMessengerUrlComponent;



// WEBPACK FOOTER //
// ./src/components/share/FBMessengerUrl.js